<template>
  <div class="border mr-1">
    <v-row :class="{ line: !show }" class="ma-1 px-0">
      <v-col cols="auto">
        <div @click="alteraViewCard()" class="font-primaria title font-weight-bold titulo font-color-print">
          {{ titulo }}
          <icon v-if="showIcon" class="primary1--text" :name="show ? 'plus-circle' : 'x-circle'" :size="18" />
        </div>
      </v-col>
    </v-row>

    <v-expand-transition>
      <v-row class="ma-1" v-if="!show">
        <v-col cols="12" sm="6">
          <div class="primary1--text subtitle-1 font-secundaria">Versão Anterior - {{ versaoAnterior }}</div>

          <div
            v-for="(item, index) in arrHistoricoAnterior"
            class="subtitle-2 font-color-print"
            ref="col1"
            :key="index"
            :class="item.valor.length > 1 ? 'altura-col' : ''"
            :style="estiloShow(index)"
          >
            <span class="font-weight-bold font-color-print font-secundaria subtitle-1"> {{ item.nomeCampo }} </span>

            <div
              v-if="item.valor && item.valor.length === 1"
              class="subtitle-2 font-secundaria"
              :style="isParticipacao(item)"
              :class="estilizacaoCampo(item, index, null, null, versaoAnterior)"
            >
              {{ item.valor[0] }}
            </div>

            <div
              v-else-if="item.valor && item.valor.length > 1"
              v-for="(i, idx) in item.valor"
              class="font-secundaria"
              ref="refArrayAntigo"
              :style="estiloArrayAntigoNovo(idx)"
              :key="idx"
              :class="estilizacaoCampo(item, index, i, idx, versaoAnterior)"
            >
              {{ i }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6">
          <div class="primary1--text subtitle-1 font-secundaria">Nova Versão - {{ versaoNova }}</div>

          <div
            v-for="(item, index) in arrHistoricoNova"
            class="subtitle-2 font-color-print"
            ref="col2"
            :key="index"
            :class="item.valor.length > 1 ? 'altura-col' : ''"
            :style="estiloShow(index)"
          >
            <span class="font-weight-bold font-color-print font-secundaria subtitle-1"> {{ item.nomeCampo }} </span>

            <div
              v-if="item.valor && item.valor.length === 1"
              class="subtitle-2 font-secundaria"
              :style="isParticipacao(item)"
              :class="estilizacaoCampo(item, index, null, null, versaoNova)"
            >
              {{ item.valor[0] }}
            </div>

            <div
              v-else-if="item.valor && item.valor.length > 1"
              v-for="(i, idx) in item.valor"
              class="font-secundaria"
              ref="refArrayNovo"
              :style="estiloArrayAntigoNovo(idx)"
              :key="idx"
              :class="estilizacaoCampo(item, index, i, idx, versaoNova)"
            >
              {{ i }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      required: false,
      default: ''
    },
    versaoAnterior: {
      type: [Number, String],
      default: 254
    },
    versaoNova: {
      type: [Number, String],
      default: 255
    },
    arrHistoricoAnterior: {
      type: Array,
      default: () => []
    },
    arrHistoricoNova: {
      type: Array,
      default: () => {
        return []
      }
    },
    showIcon: {
      type: Boolean
    }
  },
  data() {
    return {
      show: true
    }
  },
  mounted() {
    this.$forceUpdate()

    if (this.arrHistoricoAnterior.length > 0 || this.arrHistoricoNova.length > 0) this.show = false
  },
  methods: {
    isParticipacao(item) {
      if (item.nomeCampo === 'Participações Societárias') return 'white-space: pre-line;'
    },
    alteraViewCard() {
      if (!this.showIcon) return
      this.show = !this.show
    },
    estilizacaoCampo(itemCampo, indexCampo, itemArray, indexArray, numeroVersao) {
      //Retornar estilização padrão para o valor do campo Justificativa
      if (itemCampo.nomeCampo === 'Justificativa') return null

      if (this.titulo.includes('Perfil') && indexArray == 0) {
        return 'font-color-print'
      }

      if (!itemArray) {
        return this.versaoAnterior === numeroVersao
          ? this.estiloUnicoHistoricoAntigo(itemCampo, indexCampo)
          : this.estiloUnicoHistoricoNova(itemCampo, indexCampo)
      }

      return this.versaoAnterior === numeroVersao
        ? this.estiloArrayHistoricoAntigo(itemCampo, indexCampo, itemArray, indexArray)
        : this.estiloArrayHistoricoNova(itemCampo, indexCampo, itemArray, indexArray)
    },

    estiloUnicoHistoricoAntigo(item, index) {
      if (item.valor[0] != '' && this.arrHistoricoNova[index].valor[0] == '' && this.titulo == 'Área de Ação') {
        return 'primary5--text font-weight-bold'
      }

      // return item.valor.length > 1 || item.valor[0] !== this.arrHistoricoNova[index].valor[0]
      //   ? 'primary1--text font-weight-bold'
      //   : 'font-color-print'
      return 'font-color-print';
    },
    estiloUnicoHistoricoNova(item, index) {
      // return item.valor.length > 1 || item.valor[0] !== this.arrHistoricoAnterior[index].valor[0]
      //   ? 'primary1--text font-weight-bold'
      //   : 'font-color-print'
      return item.valor.length > 1 || !this.containsItemArray(item.valor[0], this.arrHistoricoAnterior)       
        ? 'primary1--text font-weight-bold'
        : 'font-color-print'
    },
    containsItemArray(item, arrayItems) {
      let items = arrayItems.map((x) => x.valor[0]).filter(t => t !== '');
      return items.includes(item);
    },
    estiloArrayHistoricoAntigo(item, index, idx, i) {
      if (this.arrHistoricoNova[index].valor[i] == '' && this.titulo == 'Endereços') {
        const valores = item.valor.filter((it) => it == '').length
        if (valores != item.valor.length) return 'primary5--text font-weight-bold'
      }

      return this.arrHistoricoNova[index].valor && i !== this.arrHistoricoNova[index].valor[idx]
        ? 'primary1--text font-weight-bold'
        : 'font-color-print'
    },
    estiloArrayHistoricoNova(item, index, idx, i) {
      return this.arrHistoricoAnterior[index].valor && i !== this.arrHistoricoAnterior[index].valor[idx]
        ? 'primary1--text font-weight-bold'
        : 'font-color-print'
    },

    estiloShow(index) {
      return this.show
        ? {
            'min-height': `${
              this.$refs.col1
                ? this.$refs.col1[index].clientHeight > this.$refs.col2[index].clientHeight
                  ? this.$refs.col1[index].clientHeight
                  : this.$refs.col2[index].clientHeight
                : ''
            }px`
          }
        : {}
    },
    estiloArrayAntigoNovo(idxLinha) {
      let height
      if (this.$refs.col1) {
        height =
          this.$refs.refArrayAntigo[idxLinha].clientHeight == this.$refs.refArrayNovo[idxLinha].clientHeight
            ? this.$refs.refArrayAntigo[idxLinha].clientHeight
            : this.$refs.refArrayAntigo[idxLinha].clientHeight > this.$refs.refArrayNovo[idxLinha].clientHeight
            ? this.$refs.refArrayAntigo[idxLinha].clientHeight
            : this.$refs.refArrayNovo[idxLinha].clientHeight

        return `min-height: ${height}px`
      }
    }
  }
}
</script>

<style>
.line {
  border-bottom: 1px solid #9e9e9e80;
}
.titulo {
  cursor: pointer !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.border {
  border: 1px solid #00995d;
  border-radius: 5px;
}

.altura-col {
  padding-bottom: 1rem;
}

.primary5--text {
  color: #f0666f !important;
  caret-color: #f0666f !important;
}
</style>
